export default {
  SET_BRAINS: (state, payload) => {
    state.brains = payload;
  },
  SET_QUESTIONNAIRE: (state, payload) => {
    state.questionnaire = payload;
  },

};
